import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router';

import config from 'config';

import GoogleTagManager from '../components/GoogleTagManager';
import ThirdPartyScriptsWrapper from 'apps/thirdPartyScripts/containers/ThirdPartyScriptsWrapper';

const GoogleTagManagerContainer = ({ isGtmEnabled }) => {
  if (!isGtmEnabled) {
    return null;
  }

  return (
    <ThirdPartyScriptsWrapper>
      <GoogleTagManager gtmId={config.gtmId} />
    </ThirdPartyScriptsWrapper>
  );
};

GoogleTagManagerContainer.propTypes = {
  isGtmEnabled: PropTypes.bool.isRequired,
};

export default withRouter(connect(
  state => ({
    isGtmEnabled: get(state, 'user.features', []).includes('GOOGLE_TAG_MANAGER'),
  })
)(GoogleTagManagerContainer));
